import cn from 'classnames';
import styles from './BottomDrawer.module.scss';
import { CupertinoPane } from 'cupertino-pane';
import { useEffect, useRef } from 'react';
import { Flex, Divider } from '..';
import { copyToClipboard } from '@/services/copy-to-clipboard';

export const BottomDrawer = ({
  children,
  closeFn,
  active,
  className,
  drawerId,
  linkToCopy,
}) => {
  const wrapperClassName = cn(styles.wrapper, className);
  const contentClassName = cn(styles.content, {
    [styles.closed]: !active,
  });
  const PaneRef = useRef(null);

  const settings = {
    bottomClose: true,
    buttonDestroy: false,
    draggableOver: false,
    events: {
      onBackdropTap: () => {
        PaneRef.current?.hide();
        closeFn();
      },
      onWillDismiss: () => {
        PaneRef.current?.hide();
        closeFn();
      },
    },
  };

  const handleCopyClick = () => {
    copyToClipboard(linkToCopy);
    closeFn();
  };

  useEffect(() => {
    const root = document.querySelector('body');

    if (active && root) {
      root.classList.add('modal-opened');
    }
    if (!active && root) {
      root.classList.remove('modal-opened');
    }
  }, [active]);

  useEffect(() => {
    if (!PaneRef.current && active) {
      PaneRef.current = new CupertinoPane(`#${drawerId}`, {
        ...settings,
        parentElement: '#__next',
        cssClass: wrapperClassName,
        fitHeight: true,
        backdrop: true,
        simulateTouch: true,
        fastSwipeClose: true,
      });

      PaneRef.current.present({ animate: true });
    }

    return () => {
      if (PaneRef.current) {
        PaneRef.current.destroy({ animate: true });
        PaneRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, drawerId]);

  return (
    <>
      <div id={drawerId} className={contentClassName}>
        {linkToCopy && (
          <>
            <Flex
              align="center"
              gap={12}
              className={styles.shareItem}
              onClick={handleCopyClick}
            >
              <img loading="lazy" src="/svg/copy.svg" alt="Copy link icon" />{' '}
              Copy link
            </Flex>

            <Divider noMargin className={styles.divider} />
          </>
        )}
        {children}
      </div>
    </>
  );
};
